<template>
    <div class="panel__container">
        <div class="options">
            <div class="options__item">
                <h2 class="options__item__title">Add people to this channel</h2>
                <p class="options__item__description">Add members from your {{ tenant.display_name }} workspace to this channel</p>
                <p class="options__item__action">
                    <router-link :to="{ name: 'people.add', params: { channel: channel.slug }}" class="button button--primary">Add people</router-link>
                </p>
            </div>
            <div class="options__item">
                <h2 class="options__item__title">Invite guests to this channel</h2>
                <p class="options__item__description">Invite new people to join skybase and this channel</p>
                <p class="options__item__action">
                    <router-link :to="{ name: 'people.invite', params: { channel: channel.slug }}" class="button button--primary">Invite guests</router-link>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('tenant', {
            tenant: 'tenant'
        }),

        ...mapState('channel', ['channel'])
    }
}
</script>
